import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6db3dd08"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "my-tabs"
};
const _hoisted_2 = ["onClick"];
import { onMounted, nextTick, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'myTabs',
  props: {
    tabLists: {
      type: Array,
      default: () => [],
      required: true
    },
    tabKey: {
      type: String,
      default: 'key'
    },
    tabValue: {
      type: [String, Number],
      default: 'value'
    },
    objectKey: {
      type: String,
      default: ''
    },
    currentActive: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['onTabClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const tabsListRef = ref(null);
    const tabsListInnerRef = ref(null); // onMounted(() => {
    //     // console.log(6666666666, tabsListRef.value.clientWidth);
    //     // console.log(7777777777, tabsListInnerRef.value.offsetWidth);
    // })

    const onTabClick = item => {
      currentActiveItem.value = item[props.tabValue];
      const params = props.objectKey ? {
        objectKey: props.objectKey,
        ...item
      } : item;
      emit('onTabClick', params);
    };

    const currentActiveItem = ref(null);

    const getCurrentActive = () => {
      if (props.currentActive == null) return;
      const item = props.tabLists.filter(item => item[props.tabValue] == props.currentActive)[0];
      currentActiveItem.value = item && item[props.tabValue];
    };

    getCurrentActive();

    const isShowArrow = () => {
      setTimeout(() => {
        if (tabsListInnerRef.value.scrollLeft > 0) {
          showleftArrow.value = true;
        } else {
          showleftArrow.value = false;
        }

        if (showRightArrow.value && tabsListInnerRef.value.scrollWidth > tabsListRef.value.offsetWidth && tabsListInnerRef.value.scrollWidth - tabsListInnerRef.value.scrollLeft == tabsListRef.value.offsetWidth) {
          showRightArrow.value = false;
        } else if (tabsListInnerRef.value.scrollWidth > tabsListRef.value.offsetWidth && tabsListInnerRef.value.scrollWidth - tabsListInnerRef.value.scrollLeft > tabsListRef.value.offsetWidth) {
          showRightArrow.value = true;
        }
      }, 200);
    };

    const arrowClick = direction => {
      const halfWidth = tabsListRef.value.offsetWidth / 3;
      const scrollLeft = tabsListInnerRef.value.scrollLeft;
      tabsListInnerRef.value.scrollLeft = direction == 'left' ? scrollLeft - halfWidth : scrollLeft + halfWidth;
      isShowArrow();
    };

    const showleftArrow = ref(false);
    const showRightArrow = ref(false);

    const setItemCenter = () => {
      nextTick(() => {
        let item = tabsListInnerRef.value.querySelectorAll('.is-active')[0];
        const halfWidth = tabsListRef.value.offsetWidth / 2;

        if (item) {
          if (item.offsetLeft > halfWidth) {
            tabsListInnerRef.value.scrollLeft = item.offsetLeft - halfWidth + item.offsetWidth / 2;
          } else {
            tabsListInnerRef.value.scrollLeft = item.scrollLeft;
          }

          isShowArrow();
        }
      });
    };

    watch(() => [tabsListRef.value, tabsListInnerRef.value], val => {
      if (val[0] && val[1] && val[0].offsetWidth && val[1].scrollWidth) {
        // console.log(val[0].offsetWidth, val[1].offsetWidth);
        // console.dir(val[0]);
        // console.dir(val[1]);
        if (val[1].scrollWidth > val[0].offsetWidth) {
          showRightArrow.value = true;
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => currentActiveItem.value, val => {
      setItemCenter();
    });
    const timer = ref(null);

    const resizeHandler = e => {
      if (timer.value) clearTimeout(timer.value);
      timer.value = setTimeout(() => {
        console.log('window resize');

        if (tabsListInnerRef.value.scrollWidth > tabsListRef.value.offsetWidth) {
          showRightArrow.value = true;
        } else {
          showleftArrow.value = false;
          showRightArrow.value = false;
        }
      }, 100);
      setItemCenter();
    };

    onMounted(() => {
      window.addEventListener("resize", resizeHandler, false);
      setItemCenter();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", resizeHandler, false);
      clearTimeout(timer.value);
      timer.value = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("i", {
        style: _normalizeStyle('visibility:' + (showleftArrow.value ? '' : 'hidden')),
        class: "iconfont icon-normal",
        onClick: _cache[0] || (_cache[0] = $event => arrowClick('left'))
      }, null, 4), _createElementVNode("div", {
        ref_key: "tabsListRef",
        ref: tabsListRef,
        class: "tabs-outside"
      }, [_createElementVNode("ul", {
        class: "tabs-inner hide-scrollbar",
        ref_key: "tabsListInnerRef",
        ref: tabsListInnerRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabLists, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["tabs-item pointer", item[__props.tabValue] == currentActiveItem.value ? 'is-active' : '']),
          onClick: $event => onTabClick(item)
        }, _toDisplayString(item[__props.tabKey]), 11, _hoisted_2);
      }), 256))], 512)], 512), _createElementVNode("i", {
        style: _normalizeStyle('visibility:' + (showRightArrow.value ? '' : 'hidden')),
        class: "iconfont icon-ic_chevron_right_px",
        onClick: _cache[1] || (_cache[1] = $event => arrowClick('right'))
      }, null, 4)]);
    };
  }

});